import { amplitude } from './amplitude';
import { facebook } from './facebook';
import { smartlook } from './smartlook';

export const vendors = {
  amplitude,
  facebook,
  smartlook,
};
